// extracted by mini-css-extract-plugin
export default {"root":"promo_codes_page_root__9H-jJ","listWrap":"promo_codes_page_listWrap__pBmHC","createButton":"promo_codes_page_createButton__rC8ri"};